module.exports = __webpack_public_path__ + "static/media/settings.83277ffc.svg";